import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/nikeapp")({
  component: NikeAppSectionLayout,
});

function NikeAppSectionLayout() {
  return <Outlet />;
}
